import { gql } from "generated-graphql";

export const SCOUT_EVAL_DASHBOARD_FOR_STAFF = gql(`
  query ScoutEvalDashboardForStaff($evalLimit: Int) {
    getScoutEvalDashboardForStaff(evalLimit: $evalLimit) {
      benchmarks {
        id
        key
        name
        description
        enabled
        defaultFailUnderScore
        config
        createdAt
        updatedAt
        questions {
          id
          questionKey
          prompt
          expectedAnswer
          tags
          weight
          sortOrder
          enabled
          requirements
          sourceNotes
          sourceLinks {
            label
            url
          }
          criteria {
            id
            criterionKey
            questionKey
            category
            instructions
            maxPoints
            scorerType
            scoreAggregationRole
            sortOrder
            enabled
            requirements
          }
        }
      }
      evals {
        id
        benchmarkId
        jobId
        benchmarkKey
        benchmarkName
        status
        score
        questionCount
        config
        failureReason
        model
        estimatedCostUsd
        answerEstimatedCostUsd
        judgeEstimatedCostUsd
        startedAt
        completedAt
        createdAt
        updatedAt
        questionResults {
          id
          questionId
          questionKey
          prompt
          expectedAnswerSnapshot
          tags
          questionWeight
          status
          score
          maxScore
          failureReason
          scoutConversationId
          judgeConversationId
          answerSummary
          estimatedCostUsd
          answerEstimatedCostUsd
          judgeEstimatedCostUsd
          startedAt
          completedAt
          createdAt
          updatedAt
          rubricResults {
            id
            criterionId
            criterionKey
            category
            scorerType
            maxPoints
            pointsAwarded
            passed
            explanation
            evidence
            scoreAggregationRole
            createdAt
          }
        }
      }
    }
  }
`);
